import { useCallback, useMemo } from 'react';

import { TableCell, TableRow } from '@mui/material';

import { CustomTable } from 'components/table/custom-table';
import { IconMessage } from 'components/icon-message';
import { PlanTableActionsPopper } from './components';

import { useGetPlansQuery } from 'redux/apis/users/users-api';
import { mapPlansToTableRows, PlanTableRow, DEFAULT_PLANS_TABLE_META } from 'pages/plans/utils';

import { useQueries } from 'hooks/useQueries/useQueries';

import { planTableStyles } from './styles';

import { ReactComponent as MessageIcon } from 'assets/icons/error-msg.svg';

import { PaymentPlan } from 'utils/types';

interface IProps {
  onEditPlan: (plan: PaymentPlan) => void;
}

export const PlanTable = ({ onEditPlan }: IProps) => {
  const { parsedQueries } = useQueries();
  const { data, isLoading, isFetching, isError } = useGetPlansQuery(parsedQueries);

  const headerCells = useMemo(
    () => [
      'Plan Name',
      '# of Projects',
      '# of Users',
      'Storage',
      'Monthly Amount',
      'Annual Amount',
      ' ',
    ],
    []
  );

  const tableData = useMemo(() => mapPlansToTableRows(data?.items ?? []), [data?.items]);

  const PlanRow = useCallback(
    (plan: PlanTableRow) => (
      <TableRow sx={planTableStyles.tableRow} key={plan.id}>
        <TableCell align="left">{plan.name}</TableCell>
        <TableCell align="left">{plan.ofProjects}</TableCell>
        <TableCell align="left">{plan.ofUsers}</TableCell>
        <TableCell align="left">{plan.storageLimit}</TableCell>
        <TableCell align="left">{plan.mohtlyAmount}</TableCell>
        <TableCell align="left">{plan.annualAmount}</TableCell>
        <TableCell align="center" sx={{ width: '48px', boxSizing: 'border-box', padding: 0 }}>
          <PlanTableActionsPopper plan={plan.sourcePlan} onEditPlan={onEditPlan} />
        </TableCell>
      </TableRow>
    ),
    [onEditPlan]
  );

  if (isError) {
    return (
      <IconMessage
        icon={<MessageIcon width={150} height={150} />}
        text1={{ text: 'Failed to load plans.', size: '24px' }}
      />
    );
  }

  return (
    <CustomTable
      isLoading={isLoading || isFetching}
      headerCells={headerCells}
      tableMeta={data?.meta ?? DEFAULT_PLANS_TABLE_META}
      tableData={tableData}
      renderRow={PlanRow}
    />
  );
};
